import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const contactInfo = [
    {
      icon: '📞',
      label: 'Phone',
      value: '+960 9977542 / +960 9726168',
      href: 'tel:+9609977542'
    },
    {
      icon: '📧',
      label: 'Email',
      value: 'hello@saltfishy.com',
      href: 'mailto:hello@saltfishy.com'
    },
    {
      icon: '📍',
      label: 'Location',
      value: 'Marine Drive, Malé 20026, Maldives',
      href: '#'
    },
    {
      icon: '🕐',
      label: 'Hours',
      value: 'Sun-Thu: 8AM - 4PM',
      href: '#'
    }
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitted(true);
      setFormData({ name: '', email: '', phone: '', message: '' });
      
      // Hide success message after 3 seconds
      setTimeout(() => {
        setSubmitted(false);
      }, 3000);
    }, 2000);
  };

  return (
    <div style={{ background: 'var(--background)', minHeight: '100vh', paddingTop: '80px' }}>
      <div className="container" style={{ paddingBottom: '80px' }}>
        
        {/* Hero Section */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 1rem',
            borderRadius: '50px',
            background: 'hsl(200, 85%, 25%, 0.1)',
            color: 'var(--primary)',
            marginBottom: '1rem'
          }}>
            <span style={{ fontSize: '1.5rem' }}>📞</span>
            <span style={{ fontSize: '0.875rem', fontWeight: '500' }}>Get in Touch</span>
          </div>
          <h1 className="font-display" style={{
            fontSize: 'clamp(3rem, 8vw, 5rem)',
            fontWeight: 'bold',
            color: 'var(--foreground)',
            marginBottom: '1rem'
          }}>
            Contact Us
          </h1>
          <p style={{
            color: 'var(--muted-foreground)',
            maxWidth: '42rem',
            margin: '0 auto',
            fontSize: '1.25rem',
            lineHeight: '1.6'
          }}>
            Have questions about a specific fish or need advice on your aquarium? We're here to help!
          </p>
        </div>

        {/* Contact Content */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr', 
          gap: '3rem',
          '@media (min-width: 1024px)': {
            gridTemplateColumns: '2fr 3fr'
          }
        }}>
          
          {/* Contact Info */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            
            {/* Contact Information Card */}
            <div className="reef-card" style={{ padding: '1.5rem' }}>
              <h3 className="font-display" style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: 'var(--foreground)',
                marginBottom: '1.5rem'
              }}>
                Contact Information
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {contactInfo.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1rem',
                      padding: '0.75rem',
                      borderRadius: '0.5rem',
                      textDecoration: 'none',
                      color: 'inherit',
                      transition: 'background 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = 'var(--muted)'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                  >
                    <div style={{
                      width: '2.5rem',
                      height: '2.5rem',
                      borderRadius: '0.5rem',
                      background: 'hsl(200, 85%, 25%, 0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.25rem',
                      transition: 'background 0.3s ease'
                    }}>
                      {item.icon}
                    </div>
                    <div>
                      <div style={{ fontSize: '0.875rem', color: 'var(--muted-foreground)' }}>
                        {item.label}
                      </div>
                      <div style={{ fontWeight: '500', color: 'var(--foreground)' }}>
                        {item.value}
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* WhatsApp CTA */}
            <div style={{
              background: 'var(--gradient-ocean)',
              borderRadius: 'var(--radius)',
              padding: '1.5rem',
              color: 'white'
            }}>
              <h3 className="font-display" style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                marginBottom: '0.5rem'
              }}>
                Quick Inquiry?
              </h3>
              <p style={{
                color: 'rgba(255, 255, 255, 0.8)',
                fontSize: '0.875rem',
                marginBottom: '1rem',
                lineHeight: '1.5'
              }}>
                Message us on WhatsApp for instant responses about fish availability and pricing.
              </p>
              <a 
                href="https://wa.me/9609977542" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <button className="btn-hero" style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  backdropFilter: 'blur(4px)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                  e.target.style.transform = 'translateY(0)';
                }}
                >
                  <span style={{ fontSize: '1.25rem' }}>💬</span>
                  WhatsApp Us
                </button>
              </a>
            </div>
          </div>

          {/* Contact Form */}
          <div className="reef-card" style={{ padding: '1.5rem' }}>
            <h3 className="font-display" style={{
              fontSize: '1.25rem',
              fontWeight: '600',
              color: 'var(--foreground)',
              marginBottom: '1.5rem'
            }}>
              Send us a Message
            </h3>

            {submitted && (
              <div style={{
                padding: '1rem',
                background: 'rgba(85, 239, 196, 0.1)',
                border: '1px solid rgba(85, 239, 196, 0.3)',
                borderRadius: 'var(--radius)',
                marginBottom: '1.5rem',
                color: 'var(--foreground)'
              }}>
                ✅ Message sent successfully! We'll get back to you soon.
              </div>
            )}

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: 'var(--foreground)',
                    marginBottom: '0.5rem'
                  }}>
                    Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your name"
                    required
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid var(--border)',
                      borderRadius: 'var(--radius)',
                      fontSize: '1rem',
                      background: 'var(--background)',
                      color: 'var(--foreground)',
                      transition: 'border-color 0.2s ease'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--border)'}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: 'var(--foreground)',
                    marginBottom: '0.5rem'
                  }}>
                    Email *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your@email.com"
                    required
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid var(--border)',
                      borderRadius: 'var(--radius)',
                      fontSize: '1rem',
                      background: 'var(--background)',
                      color: 'var(--foreground)',
                      transition: 'border-color 0.2s ease'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--primary)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--border)'}
                  />
                </div>
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: 'var(--foreground)',
                  marginBottom: '0.5rem'
                }}>
                  Phone (optional)
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+960 123 4567"
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid var(--border)',
                    borderRadius: 'var(--radius)',
                    fontSize: '1rem',
                    background: 'var(--background)',
                    color: 'var(--foreground)',
                    transition: 'border-color 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--primary)'}
                  onBlur={(e) => e.target.style.borderColor = 'var(--border)'}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: 'var(--foreground)',
                  marginBottom: '0.5rem'
                }}>
                  Message *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your inquiry..."
                  rows={5}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid var(--border)',
                    borderRadius: 'var(--radius)',
                    fontSize: '1rem',
                    background: 'var(--background)',
                    color: 'var(--foreground)',
                    transition: 'border-color 0.2s ease',
                    resize: 'vertical',
                    fontFamily: 'inherit'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--primary)'}
                  onBlur={(e) => e.target.style.borderColor = 'var(--border)'}
                />
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="btn-hero"
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  fontSize: '1rem',
                  padding: '0.875rem 1.5rem',
                  opacity: isSubmitting ? 0.7 : 1,
                  cursor: isSubmitting ? 'not-allowed' : 'pointer'
                }}
              >
                {isSubmitting ? (
                  <>
                    <span>🔄</span>
                    Sending...
                  </>
                ) : (
                  <>
                    <span>📧</span>
                    Send Message
                  </>
                )}
              </button>
            </form>
          </div>
        </div>

        {/* Additional Info Section */}
        <div style={{
          marginTop: '4rem',
          padding: '2rem',
          background: 'var(--muted)',
          borderRadius: 'var(--radius)',
          textAlign: 'center'
        }}>
          <h3 className="font-display" style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: 'var(--foreground)',
            marginBottom: '1rem'
          }}>
            🏝️ Visit Our Facility in the Maldives
          </h3>
          <p style={{
            color: 'var(--muted-foreground)',
            maxWidth: '42rem',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Located in the heart of Malé, our state-of-the-art marine fish facility welcomes visitors by appointment. 
            See our quarantine processes, meet our marine biologists, and experience the beauty of Maldivian marine life firsthand.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;